module.exports = __webpack_public_path__ + "img/happy-family-dentist.2317221e.jpeg";